import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { BaseIconComponent } from '../../private/base-icon/base-icon.component';

export type ExclamationShape = 'circle' | 'triangle';

/** Additional input: `direction:'horizontal'|'vertical' = 'horizontal'` for ellipsis direction. */
@Component({
  selector: 'icon-exclamation',
  imports: [CommonModule],
  templateUrl: './exclamation-icon.component.html',
  styleUrl: '../styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExclamationIconComponent extends BaseIconComponent {
  @Input() set shape(dir: ExclamationShape) {
    this.#shape.next(dir);
  }

  #shape = new BehaviorSubject<ExclamationShape>('triangle');
  shape$ = this.#shape.asObservable();
}
